import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { CloseIcon } from "../../../assets/icons/iconshere";

const RaiseQueryForm = ({
        moduleDetails,
        isLoggedIn,
        showQueryForm,
        setShowQueryForm,
        isSubmitted,
        setSubmitted
      }) => {

        const params = useParams();
        const moduleUUID = params?.uuid;
        const userData = useSelector((state) => state.userSlice);
        const configData = useSelector((state) => state.configSlice)

    const queryRequestValidation = Yup.object().shape({
        name: Yup.string().required("Name is required."),
        email: Yup.string().email("Invalid email address.").required("Email is required."),
        description: Yup.string().required("Description is required."),
      });
    
      const formik = useFormik({
        initialValues: {
          name: "",
          email: "",
          description: "",
        },
        validationSchema: queryRequestValidation,
        onSubmit: async (values) => {
          try {
            let applicationId = configData.config.applicationId;

            let _data = {
              name: values.name,
              email: values.email,
              description: values.description,
              moduleDetails: moduleDetails.name,
            };
            setSubmitted(false);
    
            if (isLoggedIn) {
              await axios.post(
                `${configData.config.UNO_URL}/api/user/request/${applicationId}/${moduleUUID}`,
                _data,
                {
                  headers: {
                    Authorization: `Bearer ${userData.token}`,
                  },
                }
              );
            } else {
              await axios.post(
                `${configData.config.UNO_URL}/api/user/requestPrelogin/${applicationId}/${moduleUUID}`,
                _data
              );
            }
    
    
    
          } catch (error) {
            console.log(error);
          }
        }

      });


      const closeRaiseQueryForm = () => {
        setShowQueryForm(false);
        formik.resetForm();
      }


  return (
   <>
   <Modal
        show={showQueryForm}
        onHide={closeRaiseQueryForm}
        className="NewModule"
        centered
        size="md">
        <Modal.Header className="modalheader">
          {isSubmitted ? "Raise a query" : "Thank You! Your Query Has Been Submitted"}
          <span onClick={closeRaiseQueryForm}>
            {" "}
            <CloseIcon />{" "}
          </span>
        </Modal.Header>

        <form onSubmit={formik.handleSubmit}>
          {isSubmitted ? (
            <Modal.Body>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 standardinput">
                    <div className="form-group">
                      <label className="label">
                        {" "}
                        Name
                        <input
                          type="text"
                          autoComplete="off"
                          value={formik.values.name}
                          onChange={(event) =>
                            formik.setFieldValue(event.target.name, event.target.value)
                          }
                          placeholder="Name"
                          name="name"
                          id="name"
                          className={`form-control input ${formik.errors.name && formik.touched.name ? "is-invalid" : ""
                            }`}
                        />
                        <p className="errors">
                          {formik.errors.name && formik.touched.name && formik.errors.name}
                        </p>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 standardinput">
                    <div className="form-group">
                      <label className="label">
                        {" "}
                        Email
                        <input
                          type="text"
                          autoComplete="off"
                          value={formik.values.email}
                          onChange={(event) =>
                            formik.setFieldValue(event.target.name, event.target.value)
                          }
                          placeholder="Email"
                          name="email"
                          id="email"
                          className={`form-control input ${formik.errors.email && formik.touched.email ? "is-invalid" : ""
                            }`}
                        />
                        <p className="errors">
                          {formik.errors.email && formik.touched.email && formik.errors.email}
                        </p>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 standardinput">
                    <div className="form-group">
                      <label className="label">
                        {" "}
                        Description
                        <textarea
                          type="text"
                          autoComplete="off"
                          value={formik.values.description}
                          onChange={(event) =>
                            formik.setFieldValue(event.target.name, event.target.value)
                          }
                          placeholder="Description"
                          name="description"
                          id="description"
                          className={`form-control input ${formik.errors.description && formik.touched.description
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        <p className="errors">
                          {formik.errors.description &&
                            formik.touched.description &&
                            formik.errors.description}
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          ) : (
            <>
              {" "}
              <Modal.Body className="d-flex align-items-center justify-content-center w-100 h-100">
                <span className="query-text">
                  <p className="mb-2">{`Dear, ${userData?.user?.name || "User"}`}</p>
                  <p>
                    Your query has been successfully submitted. Our team will review it shortly and
                    get back to you as soon as possible.
                    <br />
                  </p>
                  <p className="mt-5">
                    <span style={{ color: "red" }}>*</span>If you have any urgent concerns , please
                    feel free to contact us directly at <a href={`mailto:${configData.config.smtpConfig?.SUPPORT_EMAIL || ""}`}> {configData.config.smtpConfig?.SUPPORT_EMAIL || "Support"} </a>.
                    <br />
                  </p>
                </span>
              </Modal.Body>
            </>
          )}

          {isSubmitted && (
            <Modal.Footer className="footerbtn pt-0">
              <button className="cancel" onClick={closeRaiseQueryForm}> Cancel </button>
              <button className="save" type="submit"> Send </button>
            </Modal.Footer>
          )
          }

        </form>
      </Modal>

   </>
  )


}

export default RaiseQueryForm;